import { Button } from '@pique/component';
import { useI18n } from '@pique/i18n';
import type { ReactElement } from 'react';

import * as styles from './collection-list-header.css';

export const CollectionListHeader = ({
  node,
  onCreate,
}: {
  node: ReactElement | null;
  onCreate: () => void;
}) => {
  const t = useI18n();

  return (
    <>
      <div className={styles.collectionListHeader}>
        <div className={styles.collectionListHeaderTitle}>
          {t['com.pique.collections.header']()}
        </div>
        <Button
          className={styles.newCollectionButton}
          onClick={onCreate}
          data-testid="all-collection-new-button"
        >
          {t['com.pique.collections.empty.new-collection-button']()}
        </Button>
      </div>
      {node}
    </>
  );
};
